import TaxReceiptLinkStatusView from "@/modules/documents/presentation/views/TaxReceiptLinkStatusView.vue";
// CONSTRAINT: nginx redirects here from /documents/tax-receipts/{token} when the link cannot open
// (OPDON 410 → expired; anything else → unavailable). These two literal segments must stay distinct
// from any real token: tokens are 103 chars, and nginx proxies only segments of that shape and
// excludes exactly these two from its wrong-shape redirect (see nginx.conf).
export const documentsRoutes = [
    {
        path: "/documents/tax-receipts/expired",
        name: "TaxReceiptLinkExpired",
        component: TaxReceiptLinkStatusView,
        props: { variant: "expired" },
        meta: { titleKey: "documents.taxReceiptLink.expired.title" },
    },
    {
        path: "/documents/tax-receipts/unavailable",
        name: "TaxReceiptLinkUnavailable",
        component: TaxReceiptLinkStatusView,
        props: { variant: "unavailable" },
        meta: { titleKey: "documents.taxReceiptLink.unavailable.title" },
    },
];
export const documentsNavigationItems = [];
